import { useEffect, useMemo, useRef, useState } from "react";
import { useParams } from "react-router-dom";

import { useMeeting, usePubSub, useParticipant } from "@videosdk.live/react-sdk";

import ReactPlayer from "react-player";

// CSS
import '../../styles/videoconference.css'

import { Tooltip } from "@mui/material";

import Spinner from '../../components/Spinner.js';
import LoadingAnimation from "../../components/Loading.js";
import BackdropModal from "../../components/modals/backdrop_modal.js";
import Certificate from "./Certificate.js";
import NotaryAcknowledgment from "../notary/crud/addwizard/NotaryAcknowledgment.js";
import ImageCaptureMinimal from "../../components/ImageCaptureMinimal.js";
import ImageCaptureForLawyer from "../../components/ImageCaptureForLawyer.js";

function ParticipantView(props) {


    const cameraRef = useRef(null);

    const handleCapture = () => {
        cameraRef.current?.takePicture(); // ✅ CORRECT
    };



  const micRef = useRef(null);

  const { webcamStream, micStream, webcamOn, micOn, isLocal, displayName, captureImage, metaData, isActiveSpeaker } = useParticipant(props.participantId);

  console.log(metaData);

    const [defaultNotaryImage, setDefaultNotaryImage] = useState("");
    const [defaultFirstPartyImage, setDefaultFirstPartyImage] = useState("");
    const [defaultSecondPartyImage, setDefaultSecondPartyImage] = useState("");
    const [defaultWitnessesImage, setDefaultWitnessesImage] = useState({});
 

    const [isAnimating, setIsAnimating] = useState(false);

  const videoStream = useMemo(() => {
    if (webcamOn && webcamStream) {
      const mediaStream = new MediaStream();
      mediaStream.addTrack(webcamStream.track);
      return mediaStream;
    }
  }, [webcamStream, webcamOn]);

  useEffect(() => {
    if (micRef.current) {
      if (micOn && micStream) {
        const mediaStream = new MediaStream();
        mediaStream.addTrack(micStream.track);

        micRef.current.srcObject = mediaStream;
        micRef.current
          .play()
          .catch((error) =>
            console.error("videoElem.current.play() failed", error)
          );
      } else {
        micRef.current.srcObject = null;
      }
    }
  }, [micStream, micOn]);





    const playClickSound = () => {
      const clickSound = new Audio('/iusevolutione/assets/audio/camera_shutter.mp3'); // Provide path to your click sound
      clickSound.play();
    };



    async function imageCapture(metaData) {
      if (webcamOn && webcamStream) {
        playClickSound(); 
    
        const base64 = await captureImage();
    
        const img = new Image();
        img.src = 'data:image/jpeg;base64,' + base64;
        img.style.objectFit = 'cover';
    
        img.onload = () => {
          // Create a canvas element
          const canvas = document.createElement('canvas');
    
          // Set canvas dimensions to desired output size
          const canvasWidth = 600; // Final width
          const canvasHeight = 1000; // Final height
          canvas.width = canvasWidth;
          canvas.height = canvasHeight;
    
          const ctx = canvas.getContext('2d');
    
          
          if (metaData.user_type.toUpperCase() === "LAWYER") {
            // Set canvas dimensions to desired cropped size
            // const centerWidth = 600; // Desired width of the center region
            // const centerHeight = 1000; // Desired height of the center region
            // canvas.width = centerWidth;
            // canvas.height = centerHeight;
    
            // const ctx = canvas.getContext('2d');
    
            // // Calculate the coordinates for the center crop
            // const startX = (img.width - centerWidth) / 2;
            // const startY = (img.height - centerHeight) / 2;
    
            // // Draw the center cropped region onto the canvas
            // ctx.drawImage(img, startX, startY, centerWidth, centerHeight, 0, 0, centerWidth, centerHeight);


            handleCapture();


          }
          else{
                // Fill the entire canvas with black background
                ctx.fillStyle = 'black';
                ctx.fillRect(0, 0, canvasWidth, canvasHeight);

                // Calculate image position to center it on the canvas
                const imgAspect = img.width / img.height;
                const canvasAspect = canvasWidth / canvasHeight;

                let drawWidth, drawHeight, offsetX, offsetY;

                if (imgAspect > canvasAspect) {
                  // Image is wider than canvas
                  drawHeight = canvasHeight;
                  drawWidth = img.width * (canvasHeight / img.height);
                  offsetX = -(drawWidth - canvasWidth) / 2;
                  offsetY = 0;
                } else {
                  // Image is taller than canvas
                  drawWidth = canvasWidth;
                  drawHeight = img.height * (canvasWidth / img.width);
                  offsetX = 0;
                  offsetY = -(drawHeight - canvasHeight) / 2;
                }

                // Draw the image centered on the canvas
                ctx.drawImage(img, offsetX, offsetY, drawWidth, drawHeight);
          }

          // Convert the canvas to base64
          const croppedBase64Data = canvas.toDataURL('image/jpeg').split(',')[1];
    
          if (metaData.user_type.toUpperCase() === "LAWYER") {
            // const localStorageNotaryImage = localStorage.setItem('notary_image_'+props.transactionId, croppedBase64Data);
            // setDefaultNotaryImage(localStorageNotaryImage);
            // props.setFormData((prevFormData) => ({
            //   ...prevFormData,
            //   lawyerImage: croppedBase64Data,
            // }));
            

            
          }
          else if (metaData.user_type.toUpperCase() === "WITNESS") {
            const key = 'witnesses_image_' + props.transactionId;
            const existing = JSON.parse(localStorage.getItem(key)) || [];
          
            const witnessKey        = `witness_${metaData.contact}`;
            const nameKey           = `${witnessKey}_name`;
            const signatureKey      = `${witnessKey}_signature`;
            const witnessContactKey = `${witnessKey}_contact`;

            
            // const signatureKeyBase64 = `${witnessKey}_signature_base64`;


      
            const fullname     = `${metaData.firstname} ${metaData.middlename ?? ""} ${metaData.lastname} ${metaData.suffix ?? ""}`.trim();
          
            // Check if the witness already exists
            const index = existing.findIndex(item => item[witnessKey]);
          
            const newEntry = {
              [witnessKey]  : croppedBase64Data,
              [nameKey]     : fullname,
              [signatureKey]: metaData.signature_url,
              [witnessContactKey]: metaData.contact,
            };
          
            if (index !== -1) {
              existing[index] = newEntry; // Replace existing entry
            } else {
              existing.push(newEntry); // Add new entry
            }
          
            localStorage.setItem(key, JSON.stringify(existing));
          }



          else if (metaData.user_type.toUpperCase() === "SECOND PARTY") {
            const localStorageSecondParty = localStorage.setItem('second_party_image_'+props.transactionId, croppedBase64Data);
            localStorage.setItem('second_party_registration_id_'+props.transactionId, metaData.registrationId);

            setDefaultSecondPartyImage(localStorageSecondParty);
            props.setFormData((prevFormData) => ({
              ...prevFormData,
              secondPartyPrincipalImage: croppedBase64Data,
            }));
          }
          else {
            localStorage.setItem('first_party_image_'+props.transactionId, croppedBase64Data);
            const localStorageFirstParty = localStorage.setItem('first_party_image_'+props.transactionId, croppedBase64Data);
            

            localStorage.setItem('first_party_registration_id_'+props.transactionId, metaData.registrationId);


            setDefaultFirstPartyImage(localStorageFirstParty);
            props.setFormData((prevFormData) => ({
              ...prevFormData,
              principalImage: croppedBase64Data,
            }));
          }
        };
    
        setIsAnimating(true);
    
        setTimeout(() => {
          setIsAnimating(false);
        }, 500);
      } else {
        console.error("Camera must be on to capture an image");
      }
    }



    useEffect(() => {
      const localStorageNotaryImage = localStorage.getItem('notary_image_'+props.transactionId);
      if(localStorageNotaryImage) {
        setDefaultNotaryImage(localStorageNotaryImage);
      }
    }, [defaultNotaryImage]);

    useEffect(() => {
      const localStorageFirstPartyImage = localStorage.getItem('first_party_image_'+props.transactionId);
      if(localStorageFirstPartyImage) {
        setDefaultFirstPartyImage(localStorageFirstPartyImage);
      }
    }, [defaultFirstPartyImage]);

    useEffect(() => {
      const localStorageSecondPartyImage  = localStorage.getItem('second_party_image_'+props.transactionId);
      if(localStorageSecondPartyImage) {
        setDefaultSecondPartyImage(localStorageSecondPartyImage);
      }
    }, [defaultSecondPartyImage]);

    useEffect(() => {
      
    }, [defaultWitnessesImage]);

    const [open, setOpen] = useState(false);
  
    const handleClose = () => {
        setOpen(false);
    };

    const handleGeneratePDF = (details) => {
      setOpen(true);
    }
    

const handleImageChange = (image, keyName) => {

    // 1️⃣ update formData
    props.setFormData(prev => ({
        ...prev,
        [keyName]: image
    }));

    // 2️⃣ save to localStorage (base64 only!)
    if (typeof image === 'string') {
        localStorage.setItem(
            `notary_image_${props.transactionId}`,
            image
        );
        setDefaultNotaryImage(image);
    }

    // 3️⃣ if File → convert to base64 (if needed)
    if (image instanceof File) {
        const reader = new FileReader();
        reader.onloadend = () => {
            localStorage.setItem(
                `notary_image_${props.transactionId}`,
                reader.result
            );

            setDefaultNotaryImage(reader.result);

            props.setFormData(prev => ({
                ...prev,
                lawyerImage: reader.result
            }));
        };
        reader.readAsDataURL(image);
    }

    console.log(props);
};


  return (
    <>
      <div className={` position-relative video-cover h-100 w-100 line-wrapper my-auto ${isAnimating ? 'blinking' : ''}`}>
        {isLocal && (
          <div className={` position-absolute line-wrapper  rounded d-flex justify-content-end w-100 `} style={{ zIndex: 2 }}>




            <ImageCaptureForLawyer props={props} ref={cameraRef} onImageChange={handleImageChange} keyName="lawyerImage" preLoadedImage={defaultNotaryImage}   />


           



            {
              !defaultNotaryImage ?
                <div className="captured-image me-2 mt-2  bg-white d-flex justify-content-center text-danger d-none" style={{ border: "1px solid white", borderRadius: 10 }}>
                  <Spinner text="" />
                </div>
                :
                <img
                  src={`data:image/jpeg;base64,${defaultNotaryImage}`}
                  alt="Captured"
                  className="captured-image me-2 mt-2 d-none"
                  style={{
                    border: "1px solid white", borderRadius: 10,
                    objectFit: "cover"
                  }}
                />
            }
          </div>
        )}

        {!isLocal && metaData.user_type?.toUpperCase() === "WITNESS" && (() => {
          const witnessKey = `witnesses_image_${props.transactionId}`;
          const witnessArray = JSON.parse(localStorage.getItem(witnessKey) || '[]');

          const imageEntry = witnessArray.find(entry =>
            entry.hasOwnProperty(`witness_${metaData.contact}`)
          );

          const base64Image = imageEntry ? imageEntry[`witness_${metaData.contact}`] : null;

          return (
            <div className="position-absolute line-wrapper rounded d-flex justify-content-end w-100" style={{ zIndex: 2 }}>
              {!base64Image ? (
                <div className="captured-image me-2 mt-2 bg-white d-flex justify-content-center text-danger" style={{ border: "1px solid white", borderRadius: 10 }}>
                  <Spinner text="Capture" />
                </div>
              ) : (
                <img
                  src={`data:image/jpeg;base64,${base64Image}`}
                  alt="Captured"
                  className="captured-image me-2 mt-2"
                  style={{ border: "1px solid white", borderRadius: 10 }}
                />
              )}
            </div>
          );
        })()}



        {!isLocal && metaData.user_type?.toUpperCase() === "FIRST PARTY" && (() => {
          return (
            <div className="position-absolute line-wrapper rounded d-flex justify-content-end w-100" style={{ zIndex: 2 }}>
              {!defaultFirstPartyImage ? (
                <div className="captured-image me-2 mt-2 bg-white d-flex justify-content-center text-danger" style={{ border: "1px solid white", borderRadius: 10 }}>
                  <Spinner text="" />
                </div>
              ) : (
                <img
                  src={`data:image/jpeg;base64,${defaultFirstPartyImage}`}
                  alt="Captured"
                  className="captured-image me-2 mt-2"
                  style={{ border: "1px solid white", borderRadius: 10 }}
                />
              )}
            </div>
          );
        })()}

        {!isLocal && metaData.user_type?.toUpperCase() === "SECOND PARTY" && (() => {
          return (
            <div className="position-absolute line-wrapper rounded d-flex justify-content-end w-100" style={{ zIndex: 2 }}>
              {!defaultSecondPartyImage ? (
                <div className="captured-image me-2 mt-2 bg-white d-flex justify-content-center text-danger" style={{ border: "1px solid white", borderRadius: 10 }}>
                  <Spinner text="" />
                </div>
              ) : (
                <img
                  src={`data:image/jpeg;base64,${defaultSecondPartyImage}`}
                  alt="Captured"
                  className="captured-image me-2 mt-2"
                  style={{ border: "1px solid white", borderRadius: 10 }}
                />
              )}
            </div>
          );
        })()}





{/*  ${displayName} */}
        <span className={`badge rounded-pill  position-absolute mt-1 ms-1 fs-6 ${isLocal ? "bg-danger" :"bg-primary"}`} style={{ zIndex: 1 }}>{isLocal ? `You` : `${metaData.firstname} ${metaData.middlename} ${metaData.lastname}`}</span>
        <span className="badge rounded-pill bg-primary position-absolute ms-1 fs-6" style={{ zIndex: 1, top: 35 }}>{metaData.user_type}</span>
        <span className="badge rounded-pill bg-primary position-absolute ms-1 fs-6" style={{ zIndex: 1, top: 65 }}>{isLocal ? "" : metaData.user_id}</span>

        {!isLocal &&
          <span className="badge rounded-pill bg-primary position-absolute ms-1 fs-6" style={{ zIndex: 1, top: 65 }}>
            {micOn ? <i class='bx bxs-microphone' /> : <i class='bx bxs-microphone-off' />}
          </span>
        }


        {isActiveSpeaker &&
          <div className="position-absolute bottom-0 rounded d-flex justify-content-start mb-2 ms-2" style={{ zIndex: 1, height: 35, backgroundColor: "rgba(5, 10, 14, 1)" }}>
              <div className="btn btn-outline-secondary rounded">
                <p className="text-info mb-0 ">Speaking ..</p>
              </div>
          </div>
        }

      


        <div className="position-absolute bottom-0 w-100  d-flex justify-content-center" style={{ zIndex: 1, height: 75 }}>
          <Tooltip title="Capture Image" slotProps={{ tooltip: { sx: { fontSize: '1.15em' } } }}>
            <button type="button" className="btn btn-xl rounded-pill btn-icon btn-label-primary mt-1" onClick={() => imageCapture(metaData)} ><i className={`tf-icons bx bxs-camera`} style={{ fontSize: "xx-large" }}></i></button>
          </Tooltip>
 
        </div>

     
        <audio ref={micRef} autoPlay playsInline muted={isLocal} />

   
        {webcamOn ? (
          <div style={{ position: 'relative', width: '100%', height: '100%' }}>
            {isActiveSpeaker && (
              <div className="border border-danger border-4 rounded-3"
                style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  pointerEvents: 'none',
                  zIndex: 2,
                }}
              />
            )}
            <ReactPlayer
              //
              playsinline // extremely crucial prop`
              pip={false}
              light={false}
              controls={false}
              muted={true}
              playing={true}
              //
              url={videoStream}
              width={"100%"}
              height={"100%"}
              onError={(err) => {
                console.log(err, "participant video error");
              }}

              style={{
                objectFit: 'cover',
                transform: 'scaleX(-1)',


              }}
            />
          </div>

          )
            :
            <div className="h-100 d-flex align-items-center justify-content-center border border-dashed border-primary rounded" style={{ minHeight: 300 }}>
              <div className="text-center">
                <span className="text-primary  fw-bold border border-dashed border-primary rounded-3 text-center fs-5 mt-4 p-4">
                    {isLocal && "Your "}Camera is turned-off
                    <i className='bx bxs-camera-off  ms-2' style={{fontSize:"xxx-large"}}></i>
                </span>
              </div>
            </div>

          }
      </div>
    </>  
  );
}

export default ParticipantView